import React from "react";
import BusinessInformation from "./BusinessInformation";
import PersonalInformation from "./PersonalInformation";
import BusinessProfile from "./BusinessProfile";
import CreditCardProcessing from "./CreditCardProcessing";
import Pricing from "./Pricing";
import Equipment from "./Equipment";
import PartnerPricing from "./PartnerPricing";

function MerchantDetails({ appData }) {
  return (
    <div>
      <BusinessInformation appData={appData} />
      <PersonalInformation appData={appData} />
      <BusinessProfile appData={appData} />
      <CreditCardProcessing appData={appData} />
      {appData?.billing ? (
        <Pricing appData={appData} />
      ) : (
        <PartnerPricing appData={appData} />
      )}
      <Equipment appData={appData} />
    </div>
  );
}

export default MerchantDetails;
